export const MOBILE_ONLY_LOGO_AND_TITLE_ID = 'mobile-only-logo-and-title';

export const MOBILE_BREAKPOINT = 480;

export const codeHighlightClassHTML = 'language-html';
export const codeHighlightClassTSX = 'language-tsx';

export const THEME_OPTIONS = [
	{ label: 'Github dark', value: 'github-dark-min' },
	{ label: 'Darcula', value: 'base16-darcula-min' },
	{ label: 'Sublime', value: 'monokai-sublime-min' },
	{ label: 'Atom one dark', value: 'atom-one-dark' },
	{ label: 'Hardcore', value: 'base16-hardcore-min' },
	{ label: 'Material', value: 'base16-material-min' },
];

export const IMAGE_PREFIX = 'https://aakashdinkarh.github.io/static_assets/images/';

export const SOURCE_CODE = 'https://github.com/aakashdinkarh/smart-components-dinkar';

export const APP_CRASH = 'App Crash';
export const UNCAUGHT_ERROR = 'Uncaught Error';
export const UNHANDLED_PROMISE_REJECTION = 'Unhandled Promise Rejection';

export const STAGING = 'prod-int';
export const PRODUCTION = 'production';

export const CODE_INITIALS_LENGTH = 25;
